import axios from "@/utils/axios.js";

/**
 * Получение настроек
 */
function getSettings() {
  return new Promise((resolve, reject) => {
    axios
      .get("settings/general")
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * сохранение настроек 
 * @param {String} host
 * @param {String} port
 * @param {String} username
 * @param {String} encryption
 * @param {String} password
 * @param {String} length
 * @param {String} days_to_update
 * @param {String} uppercase
 * @param {String} lowercase
 * @param {String} numbers
 * @param {String} symbols
 */
function setSettings(data) {

  return new Promise((resolve, reject) => {
    axios
      .post("settings/general/", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function sendMail() {
  return new Promise((resolve, reject) => {
    axios
      .post(`settings/mail/check`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export { getSettings, setSettings, sendMail };
